import React from 'react';
import powerButtonImg from '../assets/compudopt-power-button.png';

/**
 * UnifiedLauncherButton Component
 *
 * Clean launcher button with flowing gradient background and power icon.
 */
const UnifiedLauncherButton = ({
  size = 60,
  onClick,
  isPressed = false,
  isHovered = false
}) => {
  // Dynamic styles based on hover/press state
  const wrapperStyle = {
    position: 'relative',
    width: size,
    height: size,
    cursor: 'pointer',
    transition: 'transform 0.15s cubic-bezier(0.4, 0, 0.2, 1), filter 0.15s ease',
    transform: isPressed ? 'scale(0.92)' : isHovered ? 'scale(1.05)' : 'scale(1)',
    filter: isPressed
      ? 'brightness(0.85) drop-shadow(0 2px 8px rgba(29, 118, 187, 0.3))'
      : isHovered
        ? 'drop-shadow(0 12px 32px rgba(29, 118, 187, 0.5)) drop-shadow(0 6px 16px rgba(0, 0, 0, 0.2))'
        : 'drop-shadow(0 8px 24px rgba(29, 118, 187, 0.4)) drop-shadow(0 4px 12px rgba(0, 0, 0, 0.15))',
  };

  return (
    <div
      style={wrapperStyle}
      onClick={onClick}
      role="button"
      aria-label="Open chat assistant"
      tabIndex={0}
      onKeyDown={(e) => {
        // role="button" must activate on Space as well as Enter;
        // preventDefault stops Space from scrolling the page
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          onClick?.();
        }
      }}
    >
      {/* Background Circle - Flowing gradient via CSS */}
      <div
        className="launcher-bg"
        style={{
          position: 'absolute',
          inset: 0,
          borderRadius: '50%',
        }}
      />

      {/* Power Icon - Centered */}
      <img
        src={powerButtonImg}
        alt=""
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '56%',
          height: '56%',
          pointerEvents: 'none',
        }}
      />
    </div>
  );
};

export default UnifiedLauncherButton;

